// @flow

import Dispatcher from 'dispatcher';
import * as StateActionTypes from 'action_types/StateActionTypes';
import State from 'models/State';
import City from 'models/City';
import ApiClient from 'utils/ApiClient';

class StateActions {
  get_states(params: {}): Promise<any> {
    let fixParams = Object.assign({},params);
    return ApiClient.get({
      path: '/states.json',
      data: fixParams,
      success: response => {
        Dispatcher.dispatch({
          type: StateActionTypes.LIST_STATES,
          states: response.state.map(state => new State(state))
        });
      }
    });
  }

  getCities(params: {}): Promise<any> {
    let fixParams = Object.assign({},params);
    return ApiClient.get({
      path: '/cities.json',
      data: fixParams,
      success: response => {
        Dispatcher.dispatch({
          type: StateActionTypes.CITIES_STATE_LIST,
          cities: response.cities.map(city => new City(city))
        });
      }
    });
  }

  getNeighborhoodCity(params: {}, success?: () => void): Promise<any> {
    let fixParams = Object.assign({},params);
    return ApiClient.get({
      path: '/neighborhoods.json',
      data: fixParams,
      success
    });
  }
}

export default new StateActions();
